import React from 'react';
import { useState, useEffect } from 'react';
import styled from 'styled-components';
import ConsumSentTable from './ConsumSentTable';
import ConsumIssueDetails from '../ConsumIssueReq/ConsumIssueDetails';
import BoToStoreConsumDetails from '../BoToStoreConsumReq/BoToStoreConsumDetails';

const Container = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`;
const Wrapper = styled.div``


const ConsumSent = ({ subTabValue }) => {
  const [row, setRow] = useState('')
    const [changepage, setChangepage] = useState([true, false, false])
  
  const handleEditclick = (e, row, reqtype) => {
    console.log(reqtype);
    setRow(row);
  
    if (["ConsumableIssue"].includes(reqtype)) {
      setChangepage([false, true, false, false, false]);
    } else if (["BoToStoreConsumIssue"].includes(reqtype)) {
      setChangepage([false, false, true, false, false]);
    } else if (["BO_User_Transfer", "BO_Store_Return"].includes(reqtype)) {
      setChangepage([false, false, false, true, false]);
    } else if (reqtype === "direct") {
      setChangepage([false, false, false, false, true]);
    }
  };
  
    const handleBack = () => {
      setChangepage([true, false, false])
    }
  return (
    <Container>
      <Wrapper>
        {changepage[0] && <ConsumSentTable subTabValue={subTabValue} handleEditclick={handleEditclick}  />}  
        {(changepage[1] ) && <ConsumIssueDetails row={row} subTabValue={subTabValue} setChangepage={setChangepage} from={"sentbox"} />}
        {(changepage[2] ) && <BoToStoreConsumDetails row={row} subTabValue={subTabValue} setChangepage={setChangepage} from={"sentbox"} />}
      </Wrapper>
    </Container>
  );
};

export default ConsumSent; 